

import React from 'react';

import './LandingPage.css';
 import { Link } from "react-router-dom";

const LandingPage = () => {
  return (
    <div className="landing-wrapper">
      

      <main className="hero">
        <h1 className="animated-text">
          {'LePic'.split('').map((char, idx) => (
            <span key={idx} className="char">{char}</span>
          ))}
        </h1>
        <p className="subtitle">Learner's Pick - One-Stop For All Types Of Educational  Content 
      <br/>  Vibrant hub of learning and innovation that encourages young minds
        </p>
        <Link to="/notes" className="cta-button">Explore Notes</Link>
        




       





      </main>

    </div>
  );
};

export default LandingPage;
